import { render } from "./GlobalAlert.vue?vue&type=template&id=34437ae8&scoped=true"
import script from "./GlobalAlert.vue?vue&type=script&lang=js"
export * from "./GlobalAlert.vue?vue&type=script&lang=js"

import "./GlobalAlert.vue?vue&type=style&index=0&id=34437ae8&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34437ae8"]])

export default __exports__